$(document).ready(function() {

  $(window).resize(function() {
    if ($(window).width() <= 480) {
      var $currentItem = $('#menu-my-account .menu-item.current-menu-item');
      $currentItem.insertBefore('#menu-my-account .menu-item:first-child');
      $currentItem.on('click', function() {
        $('#menu-my-account').toggleClass('open');
      });
      $currentItem.find('a').on('click', function(e) {
        e.preventDefault();
      });
    }
  });

});